import axios from "axios";
import dayjs from 'dayjs'
import store from "../../store/index";
export default {
  data() {
    return {
      avetagerestime:0,
      baseapi: process.env.VUE_APP_Service_URL,
      currentsiteid: "",
      uniqueSiteCodes: [],
      querycountdata:[],
      querylistforreports:[],
      querydata:[],
      lastUpdated: new Date().toLocaleString(),
      summaryMetrics: [
        {
          title: 'Total Open Queries',
          value: 0,
          threshold: 25,
          higherthreshold:true,
          higherthresholdvalue:50,
          comparison: 'lower',
          unit: '',
          description: 'Number of unresolved data queries'
        },
        {
          title: 'Avg. Resolution Time',
          value: 0,
          threshold: 5,
          higherthreshold:true,
          higherthresholdvalue:10,
          comparison: 'lower',
          unit: 'days',
          description: 'Time from query raised to closure'
        },
        {
          title: 'High Priority Queries Resolved',
          value: 0,
          threshold: 95,
          higherthreshold:false,
          higherthresholdvalue:0,
          comparison: 'higher',
          unit: '%',
          description: 'Queries linked to primary endpoint'
        },
        {
          title: 'Sites with >10 Queries',
          value: 0,
          threshold: 3,
          higherthreshold:true,
          higherthresholdvalue:10,
          comparison: 'lower',
          unit: 'sites',
          description: 'Indicator of poor site data quality'
        }
      ],
      problematicSites: [
      ],
      charts: {
        queryTrends: {
          options: {
            chart: {
              zoom: { enabled: true, type: 'x' },
              type: 'line',
              height: 350,
              toolbar: {
                show: true,
                 export: {
                  csv: { filename: 'Query Trends Over Time' },
                  png: { filename: 'Query Trends Over Time' },
                  svg: { filename: 'Query Trends Over Time' }
                },
                tools: {
                  download: true,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true
                }
              }
            },
            colors: ['#FF6384', '#36A2EB'],
            stroke: {
              curve: 'smooth',
              width: 3
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.3,
              }
            },
            markers: {
              size: 5
            },
            xaxis: {
              categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
              title: {
                text: 'Month'
              }
            },
            yaxis: {
              title: {
                text: 'Number of Queries'
              },
              min: 0
            },
            title: {              
              align: 'center',
              style: {
                fontSize: '16px'
              }
            },
            legend: {
              position: 'top'
            },
            tooltip: {
              shared: true,
              intersect: false
            }
          },
          series: [
            {
              name: 'Queries Raised',
              data: []
            },
            {
              name: 'Queries Resolved',
              data: []
            }
          ]
        },
        priority: {
          options: {
            chart: {
              type: 'donut',
              height: 400,
              // let the wrapper control width
              redrawOnParentResize: true,
              redrawOnWindowResize: true,
              toolbar: {
                show: true,
                export: {
                  // Set the base file name for each export type
                  csv: { filename: 'Query Distribution by Priority' },
                  png: { filename: 'Query Distribution by Priority' },
                  svg: { filename: 'Query Distribution by Priority' }
                }
              }
            },
            colors: ['#FF6384','#FFCD56','#4BC0C0'],
            labels: ['High','Medium','Low'],
            legend: { position: 'bottom' },
            title: { align: 'center', style: { fontSize: '16px' }},
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: { show: true, label: 'Total Queries', color: '#373d3f' }
                  }
                }
              }
            },
            // you can remove the responsive width overrides entirely
            responsive: []
          },
          series: [0,0,0]
        },
        aging: {
          options: {
            chart: {
              type: 'bar',
              height: 350,
              toolbar: {
                show: true,
                export: {
                  csv: { filename: 'Query Aging' },
                  png: { filename: 'Query Aging' },
                  svg: { filename: 'Query Aging' }
                },
              }
            },
            colors: ['#4BC0C0', '#36A2EB', '#FFCD56', '#FF9F40', '#FF6384'],
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: ['< 3 days', '3-7 days', '8-14 days', '15-21 days', '> 21 days'],
              title: {
                text: 'Age of Queries'
              }
            },
            yaxis: {
              title: {
                text: 'Number of Queries'
              }
            },
            title: {
              // text: 'Age of Open Queries',
              align: 'center',
              style: {
                fontSize: '16px'
              }
            }
          },
          series: [{
            name: 'Open Queries',
            data: [0, 0, 0, 0, 0]
          }]
        },
        resolution: {
          options: {
            chart: {
              type: 'line',
              height: 350,
              toolbar: {
                show: true,
                export: {
                  csv: { filename: 'Weekly Resolution Rate' },
                  png: { filename: 'Weekly Resolution Rate' },
                  svg: { filename: 'Weekly Resolution Rate' }
                },
              }
            },
            colors: ['#4BC0C0'],
            stroke: {
              curve: 'smooth',
              width: 3
            },
            fill: {
              type: 'gradient',
              gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.3,
              }
            },
            markers: {
              size: 5
            },
            xaxis: {
              categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Week 6'],
              title: {
                text: 'Week'
              }
            },
            yaxis: {
              title: {
                text: 'Resolution Rate (%)'
              },
              min: 75,
              max: 100
            },
            title: {
              // text: 'Weekly Resolution Rate Improvement',
              align: 'center',
              style: {
                fontSize: '16px'
              }
            }
          },
          series: [{
            name: 'Resolution Rate',
            data: [0, 0, 0, 0, 0, 0]
          }]
        }
      }
    }
  },
  beforeDestroy() {
    if (this._priorityObserver) {
      this._priorityObserver.disconnect();
    }
  },
  async mounted() {
    await this.getsites();
    await this.getquerydata();
    await this.getopenclosedcount();
    await this.getallquerylistforreports();
    this._initPriorityObserver();
    window.addEventListener("studyIdChanged", (event) => {
      this.currentsiteid="";
      this.getsites();
      this.getquerydata();
      this.getopenclosedcount();
      this.getallquerylistforreports();
    });
  },
  methods: {
    _initPriorityObserver() {
      const wrapper = this.$refs.priorityChartWrapper;
      if (!wrapper) return;

      this._priorityObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const width = entry.contentRect.width;
          const chart = this.$refs.priorityChart;
          if (chart && chart.chart) {
            chart.chart.updateOptions(
              { chart: { width: Math.floor(width) } },
              true
            );
          }
        }
      });

      this._priorityObserver.observe(wrapper);
    },
    async siteidchanges(){
      this.getquerydata();
      this.sortopenclosedcountdata();
      this.getallquerylistforreports();
    },
    async getallquerylistforreports(){
      const currentstudy = await store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.baseapi}/forms/query/getallquerylistforreports?StudyId=${currentstudy}&SiteId=${this.currentsiteid}`,
        {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            }
        })
        .then(async (res) => {
          this.querylistforreports = res.data.entities;
          await this.getcriticalqueriesresolved();
          await this.updatePrioritySeries()
          await this.updateAgingSeries();
          await this.updateResolutionSeries();
          await this.calculatetabledata();
          await this.updateSeries();
        })
        .catch((err) => console.log("error in screen list", err));
  },
  calculatetabledata() {
      // 1) bucket stats by siteCode
      const stats = {}
      this.querylistforreports.forEach(q => {
        const code = q.siteCode
        if (!stats[code]) {
          stats[code] = {
            openQueries:      0,
            criticalQueries:  0,
            totalClosedDays:  0,
            closedCount:      0
          }
        }
        const bucket = stats[code]
  
        // count open
        if (q.queryStatus === 'Open') {
          bucket.openQueries++
        }
        // count high-priority
        if (q.priority === 'High') {
          bucket.criticalQueries++
        }
        // accumulate closed-query ages
        if (q.queryStatus === 'Closed' && q.closedDate) {
          const created  = dayjs(q.createdAt)
          const closedAt = dayjs(q.closedDate, 'MM/DD/YYYY HH:mm:ss')
          bucket.totalClosedDays += closedAt.diff(created, 'day')
          bucket.closedCount++
        }
      })
  
      // 2) turn into the array your table wants
      this.problematicSites = Object.entries(stats).map(([code, b]) => {
        const avg = b.closedCount
          ? (b.totalClosedDays / b.closedCount)
          : 0
  
        return {
          id:              `SITE-${code}`,
          openQueries:     b.openQueries,
          criticalQueries: b.criticalQueries,
          avgAge:          Math.round(avg * 10) / 10  // one decimal place
        }
      })
      .sort((a, b) => b.openQueries - a.openQueries);
    },
  updateResolutionSeries() {
    const closed = this.querylistforreports.filter(q => q.queryStatus === 'Closed')
    const total  = closed.length

    const rates = []
    for (let week = 1; week <= 6; week++) {
      const cutoff = week * 7
      const count = closed.filter(q => {
        const created  = dayjs(q.createdAt)
        const closedAt = dayjs(q.closedDate, 'MM/DD/YYYY HH:mm:ss')
        return closedAt.diff(created, 'day') <= cutoff
      }).length
      rates.push(total ? Math.round((count / total) * 100) : 0)
    }

    this.charts.resolution.series[0].data = rates
  },
  updateAgingSeries() {
    const buckets = [0, 0, 0, 0, 0];
    const now = dayjs();

    this.querylistforreports
      .filter(q => q.queryStatus !== 'Closed')
      .forEach(q => {
        const age = now.diff(dayjs(q.createdAt), 'day');
        if (age < 3)          buckets[0]++;
        else if (age <= 7)    buckets[1]++;
        else if (age <= 14)   buckets[2]++;
        else if (age <= 21)   buckets[3]++;
        else                  buckets[4]++;
      });


    this.charts.aging.series[0].data = buckets;
  },
  updatePrioritySeries() {
    const counts = { High: 0, Medium: 0, Low: 0 }
    this.querylistforreports.forEach(q => {
      if (Object.prototype.hasOwnProperty.call(counts, q.priority)) {
        counts[q.priority]++
      }
    })

    console.log("counts",counts);
    this.charts.priority.series = [
      counts.High,
      counts.Medium,
      counts.Low
    ]
  },
  updateSeries() {
  // 1) extract “MMM YYYY” keys from your data
  const allKeys = Array.from(new Set(
    this.querylistforreports.map(q =>
      dayjs(q.createdAt).format('MMM YYYY')
    )
  ))

  // 2) sort descending (newest first)
  const sortedDesc = allKeys.sort((a, b) =>
    dayjs(b, 'MMM YYYY').valueOf() - dayjs(a, 'MMM YYYY').valueOf()
  )

  // 3) keep only the last 12
  const last12 = sortedDesc.slice(0, 12)

  // 4) put them back in ascending order for the x-axis
  const sortedKeys = last12.sort((a, b) =>
    dayjs(a, 'MMM YYYY').valueOf() - dayjs(b, 'MMM YYYY').valueOf()
  )

  // 5) bucket your counts, but only for those 12 months
  const bucket = {}
  this.querylistforreports.forEach(q => {
    const key = dayjs(q.createdAt).format('MMM YYYY')
    if (!sortedKeys.includes(key)) return    // skip older than 12
    if (!bucket[key]) bucket[key] = { raised: 0, resolved: 0 }
    bucket[key].raised++
    if (q.queryStatus === 'Closed') bucket[key].resolved++
  })

  // 6) build your series arrays
  const raisedData   = sortedKeys.map(k => bucket[k].raised)
  const resolvedData = sortedKeys.map(k => bucket[k].resolved)

  // 7) reassign so Vue/Apex sees a new object
  this.charts.queryTrends = {
    ...this.charts.queryTrends,
    options: {
      ...this.charts.queryTrends.options,
      xaxis: {
        ...this.charts.queryTrends.options.xaxis,
        categories: sortedKeys
      }
    },
    series: [
      { name: 'Queries Raised',  data: raisedData },
      { name: 'Queries Resolved', data: resolvedData }
    ]
  }
},
  async getcriticalqueriesresolved(){
        const highPriority = this.querylistforreports.filter(item => item.priority === "High");
        let percentageClosed = 100;
        if(highPriority.length != 0){
        const closedHighPriority = highPriority.filter(item => item.queryStatus === "Closed");
        percentageClosed = (closedHighPriority.length / highPriority.length) * 100;
        this.summaryMetrics[2].comparison = 'higher';
        this.summaryMetrics[2].unit = '%';
        this.summaryMetrics[2].value = percentageClosed;
              }
              else{
        this.summaryMetrics[2].comparison = 'lower';
        this.summaryMetrics[2].unit = '';
        this.summaryMetrics[2].value = 0;
              }
  },
    async getopenclosedcount(){
      const currentstudy = await store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.baseapi}/forms/query/getopenclosedcount?StudyID=${currentstudy}`,
        {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            }
        })
        .then((res) => {
          this.querycountdata = res.data;
          this.sortopenclosedcountdata();
        })
        .catch((err) => console.log("error in screen list", err));
    },
    getSiteCodeById(id) {
      console.log("id",id);
      const site = this.uniqueSiteCodes.find(s => s.siteID === id);
      return site ? site.siteCode : null; 
    },
    
    async sortopenclosedcountdata(){
      let openQuerycount=0;
      let totalqueries=0;
      let sitecode = this.getSiteCodeById(this.currentsiteid);
      this.querycountdata.forEach(element=>{
       
        if(sitecode == null || this.currentsiteid == ""){
          let querycount = element.openQuery+element.closedQuery;
          if(querycount>=10){
            totalqueries = totalqueries+1;
          }
          openQuerycount = openQuerycount+element.openQuery;
        }
        else{
          if(element.site == sitecode){
            openQuerycount = element.openQuery;
            let sitequerycount = element.openQuery+element.closedQuery;
            if(sitequerycount >= 10){
              totalqueries = 1;
            }
            else{
              totalqueries = 0;
            }
          }
        }
      })
      
      this.summaryMetrics[0].value = parseInt(openQuerycount);
      this.summaryMetrics[3].value = totalqueries;
    },
    async getquerydata(){
            const currentstudy = await store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            await axios.get(
              `${this.baseapi}/forms/query/getqueryreports?studyId=${currentstudy}&siteId=${this.currentsiteid}`,
              {
                  headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                  }
              })
              .then((res) => {
                this.querydata = res.data;
                this.getaveragerestime();
              })
              .catch((err) => console.log("error in screen list", err));
        },
        async getaveragerestime(){
          let averageragestime=0;
            let totalelements=0;
            let totalaverage=0;
          if(this.querydata.length != 0){
          this.querydata.forEach(element => {
            
            if(this.currentsiteid == "All" || this.currentsiteid == ""){
              totalelements = totalelements+1;
              totalaverage = totalaverage+element.average;
            }
            else{
              if(element.siteID == this.currentsiteid){
                averageragestime = element.average;
              }
            }
          });
          if(this.currentsiteid == "All" || this.currentsiteid == ""){
            averageragestime = totalaverage/totalelements;
          }
          this.summaryMetrics[1].value = Number(averageragestime.toFixed(2));
        }
        else{
          this.summaryMetrics[1].value = 0;
        }
        },
    async getsites() {
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      
      await axios
        .get(
          `${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudy}&sortProperty=siteCode&IsDes=false&getAll=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.uniqueSiteCodes = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}